// extracted by mini-css-extract-plugin
module.exports = {"paper":"AuthenticateDialog_paper__2TtDh","typeToggle":"AuthenticateDialog_typeToggle__2S3hB","signInWithProvidersDivider":"AuthenticateDialog_signInWithProvidersDivider__1DgGi"};